export default {
  ORIGIN_TOKEN: "",
  API_URL: "https://api-stage.crescolabsdev.com",
  API_KEY: "jQVtd4jQyQ3mQNkblMWRQ9SFjJJDM3Xc6QDGTZEC"
};
